import { useAuth } from "@/context/AuthContext";
import { channelLabels } from "@/lib/sectorVisibility";

// Kanal etiketi TEK KAYNAK — sabit "Market/Toptan" yazımını önler.
// Aktif sektörün kanal etiketlerini (Reçete/OTC, Depo, Menü, Vitrin...) döndürür.
export function useChannelLabels() {
  const { activeSectorObj } = useAuth();
  return channelLabels(activeSectorObj);
}

// Kanal rozeti — tüm sayfalar sabit metin yerine bunu kullanır.
// channel: "market" | "toptan" | "wholesale". upper: BÜYÜK HARF gösterim.
export function ChannelBadge({ channel = "market", upper = false, className = "", icon = null }) {
  const chl = useChannelLabels();
  const isToptan = channel === "toptan" || channel === "wholesale";
  const label = isToptan ? chl.toptan : chl.market;
  return (
    <span className={className}>
      {icon}
      {upper ? label.toUpperCase() : label}
    </span>
  );
}
